
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const Hero: React.FC = () => {
  const [showTyping, setShowTyping] = useState(true);
  const [text, setText] = useState('');
  const fullText = 'The digital realm of SpecialAgentK';
  const typingSpeed = 100;
  
  useEffect(() => {
    if (showTyping) {
      let currentIndex = 0;
      const typingInterval = setInterval(() => {
        if (currentIndex < fullText.length) {
          setText(fullText.substring(0, currentIndex + 1));
          currentIndex++;
        } else {
          clearInterval(typingInterval);
          setTimeout(() => {
            setShowTyping(false);
          }, 1000);
        }
      }, typingSpeed);
      
      return () => clearInterval(typingInterval);
    }
  }, [showTyping]);
  
  return (
    <section className="min-h-screen flex flex-col items-center justify-center pt-16 relative overflow-hidden">
      <div className="container mx-auto px-4 py-20 z-10 text-center">
        <div className="mb-8">
          <img 
            src="/lovable-uploads/2e4fef84-d034-4e81-a55c-9c795d12d513.png" 
            alt="SpecialAgentK Avatar" 
            className="w-48 h-48 md:w-64 md:h-64 mx-auto mb-4"
          />
        </div>
        
        <h1 className="text-4xl md:text-7xl font-pixel mb-8" data-text="SpecialAgentK">
          <span className="text-cyber-green">SpecialAgentK</span>
        </h1>
        
        <div className="cyber-box max-w-xl mx-auto">
          <span></span>
          <div className="font-cyber text-lg md:text-xl">
            {showTyping ? (
              <div className="h-6">
                <span>{text}</span>
                <span className="inline-block w-2 h-4 bg-cyber-green ml-1"></span>
              </div>
            ) : (
              <div className="h-6 flex items-center justify-center">
                <span>{fullText}</span>
              </div>
            )}
          </div>
          <span></span>
        </div>
        
        {/* Haiku text added below the digital realm box */}
        <div className="mt-6 text-cyber-green-muted font-cyber text-md md:text-lg italic">
          <p>SpecialAgentK—</p>
          <p>From dial-up hums to dark chains,</p>
          <p>Ghost in the net's maze.</p>
        </div>
        
        <div className="mt-12">
          <Link 
            to="/about" 
            className="inline-block font-cyber px-8 py-3 border border-cyber-green text-cyber-green hover:bg-cyber-green hover:text-cyber-black transition-all duration-300 relative overflow-hidden group"
          >
            <span className="relative z-10">ACCESS SYSTEM</span>
            <span className="absolute inset-0 bg-cyber-green transform translate-y-full group-hover:translate-y-0 transition-transform duration-300"></span>
          </Link>
        </div>
      </div>
      
      <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 5V19M12 19L5 12M12 19L19 12" stroke="#00FF66" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
    </section>
  );
};

export default Hero;
